import { render, staticRenderFns } from "./footerHome.vue?vue&type=template&id=0a6a167d&scoped=true"
import script from "./footerHome.vue?vue&type=script&lang=js"
export * from "./footerHome.vue?vue&type=script&lang=js"
import style0 from "./footerHome.vue?vue&type=style&index=0&id=0a6a167d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a167d",
  null
  
)

export default component.exports